<template>
  <div style="margin: 10px;" class="vertical-spaced-container">
    <div style="display: flex; flex-wrap: wrap-reverse;">
      <div class="flow-spaced-container" style="flex-grow: 1; align-items: flex-end;">
        <div class="filter-item" style="max-width: 300px; width: 100%;">
          <SearchInput
            v-model="query"
            updateOnChange
            updateOnInputAfterDelay
            :placeholder="'Numéro, nom, email, téléphone...'"
            style="width: 100%;" />
        </div>

        <div class="filter-item">
          <div class="filter-item-title">
            Créé
          </div>
          <DateRangeInput v-model="createdDateRange" />
        </div>

        <div class="filter-item">
          <div class="filter-item-title">
            Trier par
          </div>
          <select
            v-model="sortBy"
            class="form-select">
            <option :value="null">
              Date de création (Plus réçent d'abord)
            </option>
            <option value="created_at">
              Date de création (Plus ancien d'abord)
            </option>
          </select>
        </div>

        <div class="filter-item">
          <div class="filter-item-title">
            Status Odoo
          </div>
          <select
            v-model="odooPaymentState"
            class="form-select">
            <option value="all">
              Tout
            </option>
            <option value="not_pushed">
              Pas encore push sur Odoo
            </option>
            <option value="error">
              Erreur
            </option>
            <option value="pushed">
              Push sur Odoo
            </option>
          </select>
        </div>

        <div class="filter-item">
          <ResetFiltersButton :store="creditNoteListStore" />
        </div>
      </div>
    
      <button
        class="tool-btn tooltip"
        @click="$router.push({ name: 'create-credit-note' })">
        <InvoiceIcon status="creditNote" />
        <div class="tooltip-text left">
          Nouvel avoir
        </div>
      </button>
    </div>

    <div class="cat-list" style="margin: 5px;">
      <router-link
        :to="{ name: 'credit-note-list' }"
        class="cat-list-item"
        :class="{ 'active': !$route.query.journalId }">
        Tous
        <span
          v-if="creditNoteListStore.getTotal('all') != null">
          ({{ creditNoteListStore.getTotal('all') }})
        </span>
      </router-link>
      
      <router-link
        v-for="(journal, index) in journals"
        :key="index"
        :to="{ name: 'credit-note-list', query: { journalId: journal.id } }"
        class="cat-list-item"
        :class="{ 'active': $route.query.journalId == journal.id }">
        {{ journal.origin.code }} {{ journal.invoice_code_prefix }}
        <span
          v-if="creditNoteListStore.getTotal(journal.id) != null">
          ({{ creditNoteListStore.getTotal(journal.id) }})
        </span>
      </router-link>
    </div>

    <router-view style="min-height: 100%;" />
  </div>
</template>

<script>

import SearchInput  from "@/components/inputs/SearchInput.vue";
import ResetFiltersButton  from "@/components/buttons/ResetFiltersButton.vue";
import InvoiceIcon from "@/assets/iconsVue/InvoiceIcon.vue";
import DateRangeInput from "@/components/baseComponents/DateRangeInput.vue";
import { useCreditNoteListStore } from "@/stores/creditNoteList";
import { useJournalsStore } from "@/stores/journals";

export default {
  name: "CreditNoteListLayout",
  components: {
    SearchInput,
    ResetFiltersButton,
    DateRangeInput,
    InvoiceIcon,
  },
  data() {
    return {
      creditNoteListStore: useCreditNoteListStore(),
      journalsStore: useJournalsStore(),
    };
  },
  computed: {
    query: {
      get() {
        return this.creditNoteListStore.getFilter("q");
      },
      set(val) {
        this.creditNoteListStore.addFilter("q", val);
        this.creditNoteListStore.refresh();
      },
    },
    createdDateRange: {
      get() {
        return [
          this.creditNoteListStore.getFilter("created_at_after"),
          this.creditNoteListStore.getFilter("created_at_before"),  
        ];
      },
      set(val) {
        this.creditNoteListStore.addFilter("created_at_after", val[0]);
        this.creditNoteListStore.addFilter("created_at_before", val[1]);
        this.creditNoteListStore.refresh();
      },
    },
    sortBy: {
      get() {
        return this.creditNoteListStore.getFilter("sort_by");
      },
      set(val) {
        this.creditNoteListStore.addFilter("sort_by", val);
        this.creditNoteListStore.refresh();
      },
    },
    odooPaymentState: {
      get() {
        const res = this.creditNoteListStore.getFilter("odoo_status");
        if (res == null) {
          return "all";
        } else {
          return res;
        }
      },
      set(val) {
        if (val == "all") {
          val = null;
        }
        this.creditNoteListStore.addFilter("odoo_status", val);
        this.creditNoteListStore.refresh();
      },
    },
    journals() {
      return this.journalsStore.getJournals;
    },
  },
};
</script>

<style lang="scss" scoped>


</style>
